import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
import { optionWithId, getLookupOptions } from "../../../utils/lookup";
import { SearchFilters } from "../../../types/v1_schemas";
import FilterCheckbox from "./FilterCheckbox";
import { toggleItemInFilterList } from "../../../utils/filters/shared";

type AccessibilityInputProps = {
  legend: string;
  compact?: boolean;
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};

function AccessibilityInput({
  legend,
  compact = false,
  filters,
  setFilters,
}: AccessibilityInputProps) {
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { t } = useTranslation();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [accessibiltyOptions, setAccessibilityOptions] = useState(() => getLookupOptions("accessibility"));

  const setAccessibilityFilter = (accessibilityOption: optionWithId) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "accessibility",
      filter_type: "accessibility",
      filter_value: accessibilityOption.lineageText,
    });
    setFilters({
      ...filters,
      accessibilitySupportIds: toggleItemInFilterList(
        filters.accessibilitySupportIds ?? [],
        accessibilityOption.id.toString()
      ) as []
    });
  };

  return (
    <Fieldset legend={legend} legendStyle={compact ? "srOnly" : "large"}>
      {accessibiltyOptions.map((option: optionWithId) => (
        <FilterCheckbox
          name={option.id.toString()}
          value={option.id.toString()}
          label={t(`${option.translate}`)}
          selectedFilterValues={filters.accessibilitySupportIds ?? []}
          onChange={() => setAccessibilityFilter(option)}
          key={option.id.toString()}
        />
      ))}
    </Fieldset>
  );
}

export default AccessibilityInput;
